export default __webpack_public_path__ + "static/media/cover8.43ffb11a.jpeg";